<div>
  <h2 class="step-title">{{ cashoutTitle }}</h2>
</div>

<h3 class="slider-value">{{ sliderDisplay }}</h3>

<div class="slider-container">
  <input
    class="slider is-fullwidth is-circle is-large" type="range"
    (input)="slide($event); countVisitorAction();" [(value)]="sliderValue" min="0"
    [max]="sliderValues.length - 1"
    [sliderValue]="sliderValue"
    sliderProgress
  >
  <app-slider-label [left]="leftLabel" [right]="rightLabel" 
    [disableAddPlus]="form.controls.type.value == 'personalloan'"></app-slider-label>

  <div class="field">
    <div class="control">  
      <input
        *ngIf="inputModeTest"
        inputmode="numeric"
        class="input is-large"
        value="{{ cashOutValue }}"
        (input)="setSlide($event); countVisitorAction();"
        type="number"
        maxlength="6"
        placeholder="or type amount"
        min="0"
      >
      <input *ngIf="!inputModeTest" class="input is-large" value="{{ enterStringFieldValue }}" (input)="setSlide($event); countVisitorAction();"
        type="text" placeholder="or type amount" digitOnly>
    </div>
  </div>
</div>

<button class="button continue is-large has-shadow-small" (click)="submit(sliderValue)">
	Continue
<i class="fas fa-chevron-right"></i>
</button>
